import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m3.385-11.986c0-1.722-1.4-2.954-3.36-2.954-2.044 0-3.514 1.428-3.556 3.388l2.016.21c0-.938.588-1.582 1.47-1.582.77 0 1.288.462 1.288 1.148 0 .615-.442.934-.945 1.297-.664.48-1.435 1.037-1.435 2.455h1.974c0-.498.417-.804.913-1.168.731-.537 1.635-1.201 1.635-2.794m-4.774 5.866c0 .7.56 1.26 1.288 1.26.714 0 1.274-.56 1.274-1.26s-.56-1.246-1.274-1.246c-.728 0-1.288.546-1.288 1.246",
      clipRule: "evenodd"
    }
  )
);
var SvgQuestionFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var QuestionFilled_default = SvgQuestionFilled;

export { QuestionFilled_default as default };
